module.exports = __webpack_public_path__ + "static/img/uav-3.b491e793.png";